export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'HomeIcon',
    action: 'read',
    resource: 'Dashboard',
  },
  {
    title: 'Personas',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Empleados',
        route: 'employees',
        icon: 'BriefcaseIcon',
        action: 'read',
        resource: 'Employees',
      },
      {
        title: 'Visitantes',
        route: 'visitors',
        icon: 'UserCheckIcon',
        action: 'read',
        resource: 'Visitors',
      },
    ],
  },
  {
    title: 'Venue',
    icon: 'BookIcon',
    children: [
      {
        title: 'Eventos',
        route: 'events',
        icon: 'FileTextIcon',
        action: 'read',
        resource: 'Events',
      },
      {
        title: 'Empresas',
        route: 'companies',
        icon: 'MapPinIcon',
        action: 'read',
        resource: 'Companies',
      },
    ],
  },
  {
    title: 'Reporting',
    route: 'reporting',
    icon:'ActivityIcon', 
    action: 'read',
    resource: 'Reporting',
  },
  {
    title: 'Devices',
    route: 'devices',
    icon: 'SmartphoneIcon', 
    action: 'read',
    resource: 'Devices',
  },
  {
    title: 'Horarios',
    route: 'schedules',
    icon: 'CalendarIcon', 
    action: 'read',
    resource: 'Schedules',
  },
  {
    title: 'Configuración',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'SCA Acceso',
        route: 'aforoacces',
        icon: 'ArrowRightCircleIcon',
        action: 'read',
        resource: 'AforoAccess',
      },
      {
        title: 'SCA Puerta',
        route: 'aforodoor',
        icon: 'LogInIcon',
        action: 'read',
        resource: 'AforoDoor',
      },
      {
        title: 'Usuarios',
        route: 'users',
        icon: 'UserIcon',
        action: 'read',
        resource: 'Users',
      },
      {
        title: 'Grupo Usuario',
        route: 'user-group',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'UserGroup',
      },
    ],
  },
]
